import {
  catMixedVaccineIds,
  catSingleVaccineIds,
  dogMixedVaccineIds,
  dogSingleVaccineIds
} from '@/utils/vaccine_utils'

const state = {
  contactTypes: [],
  jobs: [],
  jobsIndexedById: {},
  masterLaboratoryCategories: [],
  masterLaboratoryCategoriesIndexedByCode: {},
  masterLaboratoryInstruments: [],
  masterLaboratoryInstrumentsIndexedByCode: {},
  masterLaboratoryItemConverters: [],
  masterLaboratoryItems: [],
  masterLaboratoryItemsIndexedByCode: {},
  masterLaboratoryReferenceRanges: [],
  masterLaboratorySpecies: [],
  masterLaboratorySpeciesIndexedByCode: {},
  masterLaboratoryUnits: [],
  masterLaboratoryUnitsIndexedByCode: {},
  noticeCategories: [],
  noticeCategoriesIndexedById: {},
  patientSexes: [],
  prefectures: [],
  prefecturesIndexedById: {},
  publicHolidays: [],
  reservationStatuses: [],
  reservationStatusesIndexedById: {},
  schemaImageClasses: [],
  schemaImageClassesIndexedById: {},
  shiftTypes: [],
  shiftTypesIndexedById: {},
  unitTypes: [],
  unitTypesIndexedById: {},
  vaccineSubNames: [],
  vaccineSubNamesIndexedById: {},
  vaccines: [],
  vaccinesIndexedById: {}
}

const getters = {
  getData(state) {
    return dataName => state[dataName]
  }, // 汎用処理
  getDataById(state) {
    return (dataName, id) => state[`${dataName}IndexedById`][id]
  }, // 汎用処理
  getContactTypes(state) {
    return state.contactTypes
  },
  getJobs(state) {
    return state.jobs
  },
  getMasterLaboratoryCategoryIndexedByCode: state => code => {
    return state.masterLaboratoryCategoriesIndexedByCode[code]
  },
  getMasterLaboratoryInstruments(state) {
    return state.masterLaboratoryInstruments
  },
  getMasterLaboratoryInstrumentIndexedByCode: state => code => {
    return state.masterLaboratoryInstrumentsIndexedByCode[code]
  },
  getMasterLaboratoryItems(state) {
    return state.masterLaboratoryItems
  },
  getMasterLaboratoryItemIndexedByCode: state => code => {
    return state.masterLaboratoryItemsIndexedByCode[code]
  },
  getMasterLaboratorySpecies(state) {
    return state.masterLaboratorySpecies
  },
  getMasterLaboratorySpeciesIndexedByCode: state => code => {
    return state.masterLaboratorySpeciesIndexedByCode[code]
  },
  getMasterLaboratoryUnitIndexedByCode: state => code => {
    return state.masterLaboratoryUnitsIndexedByCode[code]
  },
  getPrefectures(state) {
    return state.prefectures
  },
  getPrefectureIndexedById: state => prefectureId => {
    return state.prefecturesIndexedById[prefectureId]
  },
  getPublicHolidays(state) {
    return state.publicHolidays
  },
  getShiftTypes(state) {
    return state.shiftTypes
  },
  selectPatientSexesZero(state) {
    return [{ id: 0, name: '' }].concat(state.patientSexes)
  },
  selectPrefecturesZero(state) {
    return [{ id: 0, name: '' }].concat(state.prefectures)
  },
  selectUnitTypesZero(state) {
    const unitTypes = state.unitTypes.map(v => {
      return { id: v.id, name: v.name }
    })
    return [{ id: 0, name: '' }].concat(unitTypes)
  },
  selectVaccinesZero(state) {
    const orderedVaccineIds = [
      ...dogSingleVaccineIds,
      ...dogMixedVaccineIds,
      ...catSingleVaccineIds,
      ...catMixedVaccineIds
    ]
    const orderedVaccines = orderedVaccineIds
      .filter(id => !!state.vaccinesIndexedById[id])
      .map(id => {
        const vaccine = state.vaccinesIndexedById[id]
        return { id, name: vaccine.name }
      })
    return [{ id: 0, name: '' }].concat(orderedVaccines)
  }
}

const actions = {
  setData({ commit }, obj) {
    commit('setData', obj)
  },
  setKarteData({ commit }, obj) {
    commit('setKarteData', obj)
  }
}

const setDataIndexedById = (dataName, state) => {
  state[`${dataName}IndexedById`] = {}
  state[dataName].forEach(v => {
    state[`${dataName}IndexedById`][v.id] = v
  })
}

const setDataIndexedByCode = (dataName, state) => {
  state[`${dataName}IndexedByCode`] = {}
  state[dataName].forEach(v => {
    state[`${dataName}IndexedByCode`][v.code] = v
  })
}

const mutations = {
  setData(state, obj) {
    state.contactTypes = obj.contactTypes
    state.jobs = obj.jobs
    state.masterLaboratoryCategories = obj.masterLaboratoryCategories
    state.masterLaboratoryInstruments = obj.masterLaboratoryInstruments
    state.masterLaboratoryItemConverters = obj.masterLaboratoryItemConverters
    state.masterLaboratoryItems = obj.masterLaboratoryItems
    state.masterLaboratoryReferenceRanges = obj.masterLaboratoryReferenceRanges
    state.masterLaboratorySpecies = obj.masterLaboratorySpecies
    state.masterLaboratoryUnits = obj.masterLaboratoryUnits
    state.noticeCategories = obj.noticeCategories
    state.patientSexes = obj.patientSexes
    state.prefectures = obj.prefectures
    state.publicHolidays = obj.publicHolidays
    state.reservationStatuses = obj.reservationStatuses
    state.shiftTypes = obj.shiftTypes
    setDataIndexedByCode('masterLaboratoryCategories', state)
    setDataIndexedByCode('masterLaboratoryInstruments', state)
    setDataIndexedByCode('masterLaboratoryItems', state)
    setDataIndexedByCode('masterLaboratorySpecies', state)
    setDataIndexedByCode('masterLaboratoryUnits', state)
    setDataIndexedById('jobs', state)
    setDataIndexedById('noticeCategories', state)
    setDataIndexedById('prefectures', state)
    setDataIndexedById('reservationStatuses', state)
    setDataIndexedById('shiftTypes', state)
  },
  setKarteData(state, obj) {
    state.schemaImageClasses = obj.schemaImageClasses
    state.unitTypes = obj.unitTypes
    state.vaccineSubNames = obj.vaccineSubNames
    state.vaccines = obj.vaccines
    setDataIndexedById('schemaImageClasses', state)
    setDataIndexedById('unitTypes', state)
    setDataIndexedById('vaccineSubNames', state)
    setDataIndexedById('vaccines', state)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
